import type { DocumentSectionPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';
import buildDocumentEntryView, {
	type DocumentEntryView,
} from '@UI/Store/Documents/Views/buildDocumentEntryView';
import VerificationProgressView from '@UI/Store/Documents/Views/VerificationProgressView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `key: ''` marks the section of fields outside any node ("Général"), server-placed first
 * — never used as a display index, only as React `key`.
 */
class DocumentSectionView {
	readonly key: string;
	readonly title: string;
	readonly description: string | null;
	readonly progress: VerificationProgressView;
	readonly isNotApplicable: boolean;
	readonly entries: readonly DocumentEntryView[];

	constructor(payload: DocumentSectionPayload) {
		this.key = payload.key;
		this.title = payload.title;
		this.description = payload.description;
		this.progress = new VerificationProgressView(payload.progress);
		this.isNotApplicable = payload.isNotApplicable;
		this.entries = payload.entries.map(buildDocumentEntryView);

		Object.freeze(this);
	}
}

export default DocumentSectionView;
